module.exports = __webpack_public_path__ + "img/bj34.8ba3b06c.png";